import { Normal4, Tiny2, Title4 } from 'components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@dapp/multi-lib/ui/shared-hooks/useIsMobile';
import { useConnection } from 'wagmi';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import Link from 'next/link';
import { useAppDispatch } from 'store/hooks';
import { showWalletConnectModal } from 'store/features/wallet/walletSlice';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DashboardGenaralDetails = ({
  dashboardResponse,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dashboardResponse: any;
}) => {
  const { isConnected } = useConnection();
  const csr = useClientRenderDelay();
  const isMobile = useIsMobile();
  const { t } = useTranslation('dashboard');
  const isWalletConnected = csr && isConnected;
  const dispatch = useAppDispatch();
  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(showWalletConnectModal(true));
  };

  return (
    <div>
      <div className='flex items-center justify-between px-2 text-white sm:px-10 lg:px-0'>
        <Link
          href={
            isWalletConnected
              ? 'https://zealy.io/cw/singularityfinance/leaderboard'
              : ''
          }
          target={isWalletConnected ? '_blank' : ''}
          className='group flex h-max flex-col border-l-4 border-positive-800 ps-3 lg:ps-5 '
        >
          <Title4 className='pb-2 text-white lg:pb-3'>
            {t('YOUR_POINTS')} :
          </Title4>
          <Normal4 className='text-[26px] font-bold leading-7 text-positive-800 lg:text-[52px] lg:leading-[58px]'>
            {isWalletConnected && dashboardResponse?.totalPoints
              ? dashboardResponse.totalPoints
              : '0'}
          </Normal4>
          {isWalletConnected ? (
            <div>
              <div className='pt-3'>
                <Tiny2 className={`font-normal text-white-300`}>
                  {t('ZEALY_USERNAME')}:{' '}
                </Tiny2>
                <Tiny2 className={`font-normal text-positive-800`}>
                  {dashboardResponse?.zealyName || '-'}
                </Tiny2>
              </div>
              <div className='pt-1'>
                <Tiny2
                  className={`${isWalletConnected ? 'flex' : 'hidden'} font-normal text-white-500 group-hover:text-white group-hover:underline ${isMobile && 'text-[0.625rem]'}`}
                >
                  {`${t('YOUR_POINTS_SUBTITLE')}`}
                </Tiny2>
              </div>
            </div>
          ) : (
            <span
              onClick={(e) => {
                e.preventDefault();
                handleButtonClick(e);
              }}
              className={`mt-1 font-normal text-white-500 group-hover:text-white group-hover:underline ${isMobile && 'text-[0.625rem]'}`}
            >
              <Tiny2>{`(${t('CONNECT_YOUR_WALLET')})`}</Tiny2>
            </span>
          )}
        </Link>
      </div>
    </div>
  );
};
